// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .CareerContainertwo{
    color:rgba(0, 0, 0, 0.5);
  }
.careerContainerOne h6{
  margin-bottom: 0px;
}

.green-text {
  color: green;
}
.right-arrow {
  float: right;
}
.Careerdeatils{
  text-align:right;
  margin:-20px ;
}

details summary {
  list-style: none;
}

details summary::before {
  color: green;
  content: '+';
  font-size: 25px;
}

details[open] summary::before {
  content: '- ';
}

@media (max-width: 1281px){
  body{
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Career/Career2.css"],"names":[],"mappings":"EAAE;IACE,wBAAwB;EAC1B;AACF;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["  .CareerContainertwo{\r\n    color:rgba(0, 0, 0, 0.5);\r\n  }\r\n.careerContainerOne h6{\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.green-text {\r\n  color: green;\r\n}\r\n.right-arrow {\r\n  float: right;\r\n}\r\n.Careerdeatils{\r\n  text-align:right;\r\n  margin:-20px ;\r\n}\r\n\r\ndetails summary {\r\n  list-style: none;\r\n}\r\n\r\ndetails summary::before {\r\n  color: green;\r\n  content: '+';\r\n  font-size: 25px;\r\n}\r\n\r\ndetails[open] summary::before {\r\n  content: '- ';\r\n}\r\n\r\n@media (max-width: 1281px){\r\n  body{\r\n    font-size: 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
